import Vue from "vue";
import App from "./App.vue";
import Vuex from 'vuex';
import router from "./router.js";
import vuetify from '@/plugins/vuetify';
import Vuei18n from 'vue-i18n';
import messages from './lang';

Vue.use(Vuex);
Vue.use(Vuei18n);

export const i18n = new Vuei18n(
{
    locale: 'de',
    fallbackLocale: 'en',
    messages
});

const moment = require('moment');
require('moment/locale/de');
Vue.use(require('vue-moment'),
{
    moment
});

const store = new Vuex.Store(
{
    state:
    {        
        name: "",
        refreshToken: "",
        isAdmin: false,
        qlikAuthenticated: false,
        qlikToken: null,
        qlikUrl: null,
        deepLink: null,
        customers: [],
        pharmacies: [],
        countries: [],
        locale: "de"
    }
});

Vue.config.productionTip = false;

new Vue(
{
    vuetify,
    store,
    router,
    i18n,
    render: h => h(App)
}).$mount("#app");

export default store;